uniform vec2 uResolution;
uniform float uTime;
uniform float uSize;
uniform float uProgress;
uniform vec3 uColorA;
uniform vec3 uColorB;
uniform vec3 uMouse;

attribute vec3 aPositionTarget;
attribute float aSize;

varying vec3 vColor;

#include ../includes/simplexNoise3d.glsl

void main()
{
    // Mixed position
    float noiseOrigin = simplexNoise3d(position * 0.2);
    float noiseTarget = simplexNoise3d(aPositionTarget * 0.2);
    float noise = mix(noiseOrigin, noiseTarget, uProgress);
    noise = smoothstep(-1.0, 1.0, noise);
    
    float duration = 0.4;
    float delay = (1.0 - duration) * noise;
    float end = delay + duration;
    float progress = smoothstep(delay, end, uProgress);
    vec3 mixedPosition = mix(position, aPositionTarget, progress);

    // Add subtle movement based on time
    float timeScale = 1.; // 控制移动速度
    float moveAmount = 0.05; // 控制移动幅度
    vec3 movement = vec3(
        sin(uTime * timeScale + mixedPosition.x) * moveAmount,
        cos(uTime * timeScale + mixedPosition.y) * moveAmount,
        sin(uTime * timeScale + mixedPosition.z) * moveAmount
    );
    mixedPosition += movement;

    // mouse
    vec3 particle_position = (modelMatrix * vec4(mixedPosition, 1.0)).xyz;
    float distanceToMouse = pow(1. - clamp(length(uMouse.xz - particle_position.xz)-1.,0.,1.), 4.);
    vec3 dir = normalize(particle_position - uMouse);
    particle_position = mix(particle_position, uMouse + dir * 0.1, distanceToMouse);

    vec4 viewPosition = viewMatrix * vec4(particle_position, 1.0);
    
    // Final position
    //vec4 modelPosition = modelMatrix * vec4(mixedPosition, 1.0);
    //vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;
    gl_Position = projectedPosition;

    // Point size
    gl_PointSize = aSize * uSize * uResolution.y;
    gl_PointSize *= (1.0 / - viewPosition.z);

    // Varyings
    vColor = mix(uColorA, uColorB, noise);
}
